import { createVNode as _createVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'


const _hoisted_1 = { class: "genericPadding" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "fs_12 grey mt-3 d-block" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" ** ")
const _hoisted_11 = {
  key: 0,
  class: "fs_14 mt-4 d-block text-center error"
}
const _hoisted_12 = { class: "orSeparator" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_mandatory_documents = _resolveComponent("mandatory-documents")!
  const _component_mini_spinner = _resolveComponent("mini-spinner")!
  const _component_val_form = _resolveComponent("val-form")!
  const _component_social_login = _resolveComponent("social-login")!
  const _directive_localizedPlaceholder = _resolveDirective("localizedPlaceholder")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "backbutton",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
    }, [
      _hoisted_2
    ]),
    _createVNode(_component_localized_text, {
      localizedKey: "app_creaunaccount",
      text: "Crea un account",
      class: "fs_28 spaceCadet d-block mt-2"
    }),
    _createVNode(_component_localized_text, {
      localizedKey: "app_creaunaccountPerContinuare",
      text: "Crea un account per continuare",
      class: "fs_16 grey d-block mb-5"
    }),
    _createVNode(_component_val_form, {
      onNext: _ctx.doRegister,
      class: "registerContainer"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_3, [
          _withDirectives(_createVNode("input", {
            type: "text",
            class: "genericInput",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.languageCredential.name = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.languageCredential.name],
            [_directive_localizedPlaceholder, {key: 'app_nome', value: 'Nome', afterText : '*'}]
          ])
        ]),
        _createVNode("div", _hoisted_4, [
          _withDirectives(_createVNode("input", {
            type: "text",
            class: "genericInput",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.languageCredential.surname = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.languageCredential.surname],
            [_directive_localizedPlaceholder, {key: 'app_cognome', value: 'Cognome', afterText : '*'}]
          ])
        ]),
        _createVNode("div", _hoisted_5, [
          _withDirectives(_createVNode("input", {
            type: "email",
            class: "genericInput",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.languageCredential.username = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.languageCredential.username],
            [_directive_localizedPlaceholder, {key: 'app_email', value: 'Email', afterText : '*'}]
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _withDirectives(_createVNode("input", {
            type: "date",
            class: ["genericInput", {no_value : !_ctx.languageCredential.birthDate}],
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.languageCredential.birthDate = $event)),
            required: ""
          }, null, 2), [
            [_directive_localizedPlaceholder, {key: 'app_dataDiNascita', value: 'Data di nascita', afterText : '*'}],
            [_vModelText, _ctx.languageCredential.birthDate]
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _withDirectives(_createVNode("input", {
            type: "tel",
            class: "genericInput",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.languageCredential.telephone = $event))
          }, null, 512), [
            [_vModelText, _ctx.languageCredential.telephone],
            [_directive_localizedPlaceholder, {key: 'app_cell', value: 'Cell'}]
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _withDirectives(_createVNode("input", {
            type: "password",
            class: "genericInput",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.languageCredential.password = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.languageCredential.password],
            [_directive_localizedPlaceholder, {key: 'app_password', value: 'Password', afterText : '*'}]
          ]),
          _createVNode("span", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_localized_text, {
              localizedKey: "app_passwordrestrizione",
              text: "La password deve avere una lunghezza di almeno 6 caratteri, contenere una lettera maiuscola, una minuscola, e un numero",
              class: "fs_12 grey"
            })
          ])
        ]),
        (_ctx.error)
          ? (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString(_ctx.error), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_mandatory_documents, { documents: _ctx.documents }, null, 8, ["documents"]),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_mini_spinner, {
              key: 1,
              cssClass: 'my-5'
            }))
          : (_openBlock(), _createBlock("button", {
              key: 2,
              type: "submit",
              class: "genericButton bgGradient w-100 mt-5",
              disabled: !_ctx.canRegister
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "app_signUp",
                text: "Sign up",
                class: "fs_14 white"
              })
            ], 8, ["disabled"]))
      ]),
      _: 1
    }, 8, ["onNext"]),
    _createVNode("div", _hoisted_12, [
      _hoisted_13,
      _createVNode(_component_localized_text, {
        localizedKey: "app_oRegistratiCon",
        text: "o registrati con",
        class: "fs_16 grey"
      })
    ]),
    _createVNode(_component_social_login),
    _createVNode(_component_mandatory_documents, { documents: _ctx.documents }, null, 8, ["documents"]),
    _createVNode("span", {
      class: "d-block mt-5 text-center ln_12",
      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$router.push('login')))
    }, [
      _createVNode(_component_localized_text, {
        localizedKey: "app_alreadyHaveAccount",
        text: "Already have an account?",
        class: "fs_13 grey me-1"
      }),
      _createVNode(_component_localized_text, {
        localizedKey: "app_logIn",
        text: "Log in",
        class: "fs_13 blue underlined"
      })
    ])
  ]))
}